"use client";
import InpSafeForm from "@/components/atoms/FormComponents/InpSafeForm";
import { onInpSafeButtonClick } from "@/helpers/inpSafeForm";

import { Controller } from "react-hook-form";
import styles from "./styles.module.scss";
import InputV2 from "@/components/atoms/FormComponents/Input/InputV2";
import cn from "clsx";
import Consentbox from "@/components/atoms/FormComponents/ConsentBox";
import Button from "@/components/atoms/Button";
import {
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import { ALL_COUNTRIES } from "@/context/countries";
import CountryDropdownGlobal from "@/components/atoms/FormComponents/CustomDropdownGlobal/CustomDropdownGlobal";
import { useSpeakerFormController } from "./controller/useSpeakerFormController";

function SpeakerForm() {
  const {
    control,
    isValid,
    isLoading,
    isOTPLoading,
    formResponse,
    setRefs,
    handleFieldBlur,
    handleFormSubmit,
  } = useSpeakerFormController();

  return (
    <div ref={setRefs}>
      <InpSafeForm onSubmit={handleFormSubmit} className={styles.form}>
        <div className={styles.nameContainer}>
          <Controller
            name="fullName"
            control={control}
            render={({ field, fieldState }) => (
                <InputV2
                  placeholder="Jhon Doe"
                  label="Full Name *"
                  name={field.name}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("fullName", "", fieldState.error?.message);
                  }}
                  error={fieldState.error?.message}
                  disabled={isLoading || isOTPLoading}
                  id="fullName"
                />
              )}
          />

          <div className={"flex items-start gap-[1rem]"}>

          <Controller
            name="countryCode"
            control={control}
            render={({ field, fieldState }) => (
              <div className={cn("relative", styles.countryCodeContainer)}>
                <label className={styles.label} htmlFor="phone_number">Country Code*</label>
                <CountryDropdownGlobal
                  countries={ALL_COUNTRIES}
                  countryCode={field.value}
                  updateCountryCode={(val) => field.onChange(val)}
                  additionalStyle={styles.selectInput}
                  isDark={false}
                  disabled={isLoading || isOTPLoading}
                />
                {(fieldState.isTouched || !!fieldState.error) && fieldState.error && (
                  <span className={styles.error}>{fieldState.error.message}</span>
                )}
              </div>
            )}
          />

            <Controller
              name="phoneNumber"
              control={control}
              render={({ field, fieldState }) => (
                <InputV2
                  placeholder="12345 67890"
                  label="Phone Number *"
                  name={field.name}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("phoneNumber", "", fieldState.error?.message);
                  }}
                  error={fieldState.error?.message}
                  disabled={isLoading || isOTPLoading}
                  id="phone_number"
                />
              )}
            />
          </div>
        </div>

        <Controller
          name="email"
          control={control}
          render={({ field, fieldState }) => (
                <InputV2
                  placeholder="xyz@email.com"
                  label="Email Id *"
                  name={field.name}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("email", "", fieldState.error?.message);
                  }}
                  error={fieldState.error?.message}
                  disabled={isLoading || isOTPLoading}
                  id="email_id"
                />
              )}
        />

        <Controller
          name="organization"
          control={control}
          render={({ field, fieldState }) => (
                <InputV2
                  placeholder="Organization Name"
                  label="Organization *"
                  name={field.name}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("organization", "", fieldState.error?.message);
                  }}
                  error={fieldState.error?.message}
                  disabled={isLoading || isOTPLoading}
                  id="organization"
                />
              )}
        />

        <Controller
          name="linkedIn"
          control={control}
          render={({ field, fieldState }) => (
                <InputV2
                  placeholder="https://www.linkedin.com/in/xyz"
                  label="Your Linkedin Profile URL *"
                  name={field.name}
                  value={field.value ?? ""}
                  onChange={field.onChange}
                  onBlur={() => {
                    field.onBlur();
                    handleFieldBlur("linkedIn", "", fieldState.error?.message);
                  }}
                  error={fieldState.error?.message}
                  disabled={isLoading || isOTPLoading}
                  id="linkedIn"
                />
              )}
        />

        <Controller
          name="consent"
          control={control}
          render={({ field, fieldState }) => (
            <div className={cn(styles.commonMargins, "relative")}>
              <div className={cn("flex items-start")}>
                <Consentbox
                  CN={styles.boxSize}
                  attrbutes={{
                    name: field.name,
                    type: "checkbox",
                    checked: !!field.value,
                    onChange: (e) => field.onChange(e.target.checked),
                    onBlur: (e) => {
                      field.onBlur();
                      handleFieldBlur("consent", "", fieldState.error?.message);
                    },
                  }}
                  textClass={styles.consent}
                />
              </div>
              {(fieldState.isTouched || !!fieldState.error) && fieldState.error && (
                <span className={cn(styles.error)}>{fieldState.error.message}</span>
              )}
            </div>
          )}
        />

        <Button
          className={cn(
            "font-semibold font-raleway uppercase w-full border",
            styles.submitBtn
          )}
          type="button"
          onClick={onInpSafeButtonClick}
          disabled={isLoading || isOTPLoading}
        >
          SUBMIT
        </Button>
      </InpSafeForm>
      {!!formResponse?.message ? (
              <p
                className={
                  formResponse?.success
                    ? styles.successMessage
                    : styles.errorMessage
                }
              >
                {formResponse?.message}
              </p>
            ) : null}
    </div>
  );
}

const SpeakerFormOTPWrapper = () => {
  return (
    <OTPContextProvider>
      <OTPContextWrapper>
        <SpeakerForm />
      </OTPContextWrapper>
    </OTPContextProvider>
  );
};

export default SpeakerFormOTPWrapper;
